import instance from './index'

export default {
    // ==================== 认证模块 ====================
    login(username, password) {
        return instance.post('/userAuth/login', { username, password })
    },
    register(username, password, userType) {
        return instance.post('/userAuth/save', { username, password, userType, status: 1 })
    },
    sendSmsCode(phone) {
        return instance.post('/userAuth/sms/send', { phone })
    },
    smsRegister(data) {
        return instance.post('/userAuth/sms/register', data)
    },

    // ==================== 系统设置（品牌） ====================
    getSystemSettingsPublic() {
        return instance.get('/system/settings/public')
    },
    getSystemSettings() {
        return instance.get('/system/settings')
    },
    saveSystemSettings(data) {
        return instance.put('/system/settings', data)
    },
    // ==================== 通知模块 ====================
    getNotificationList(params) {
        return instance.get('/notification/list', { params })
    },
    publishNotification(text) {
        return instance.post('/notification/publish', { text })
    },
    removeNotification(id) {
        return instance.delete(`/notification/remove/${id}`)
    },

    // ==================== 会员个人中心 ====================
    getMemberProfileMe() {
        return instance.get('/member/profile/me')
    },
    updateMemberProfileMe(data) {
        return instance.put('/member/profile/me', data, {
            headers: { 'Content-Type': 'application/json' },
        })
    },
    /** category: member | coach */
    uploadProfileImage(file, category) {
        const fd = new FormData()
        fd.append('file', file)
        fd.append('category', category)
        return instance.post('/upload/image', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    },
    uploadSystemLogo(file) {
        const fd = new FormData()
        fd.append('file', file)
        return instance.post('/system/settings/logo', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    },
    getCoachProfileMe() {
        return instance.get('/coach/profile/me')
    },
    updateCoachProfileMe(data) {
        return instance.put('/coach/profile/me', data, {
            headers: { 'Content-Type': 'application/json' },
        })
    },

    // ==================== 仪表盘模块 ====================
    getDashboardStats() {
        return instance.get('/dashboard/stats')
    },

    // ==================== 会员模块 ====================
    getMemberPage(params) {
        return instance.get('/member/page', { params })
    },
    getMemberList() {
        return instance.get('/member/list')
    },
    getMemberInfo(id) {
        return instance.get(`/member/getInfo/${id}`)
    },
    saveMember(member) {
        return instance.post('/member/save', member)
    },
    updateMember(member) {
        return instance.put('/member/update', member)
    },
    removeMember(id) {
        return instance.delete(`/member/remove/${id}`)
    },

    // ==================== 教练模块 ====================
    getCoachPage(params) {
        return instance.get('/coach/page', { params })
    },
    getCoachList() {
        return instance.get('/coach/list')
    },
    getCoachInfo(id) {
        return instance.get(`/coach/getInfo/${id}`)
    },
    saveCoach(coach) {
        return instance.post('/coach/save', coach)
    },
    updateCoach(coach) {
        return instance.put('/coach/update', coach)
    },
    removeCoach(id) {
        return instance.delete(`/coach/remove/${id}`)
    },

    // ==================== 课程模块 ====================
    getCoursePage(params) {
        return instance.get('/course/page', { params })
    },
    getCourseList() {
        return instance.get('/course/list')
    },
    getCourseInfo(id) {
        return instance.get(`/course/getInfo/${id}`)
    },
    saveCourse(course) {
        return instance.post('/course/save', course)
    },
    updateCourse(course) {
        return instance.put('/course/update', course)
    },
    removeCourse(id) {
        return instance.delete(`/course/remove/${id}`)
    },

    // ==================== 预约模块 ====================
    getAppointmentStats() {
        return instance.get('/appointment/stats')
    },
    getAppointmentPage(params) {
        return instance.get('/appointment/page', { params })
    },
    saveAppointment(appointment) {
        return instance.post('/appointment/save', appointment)
    },
    createMemberAppointment(appointment) {
        return instance.post('/appointment/member/create', appointment)
    },
    updateAppointment(appointment) {
        return instance.put('/appointment/update', appointment)
    },
    confirmAppointment(id) {
        return instance.put(`/appointment/confirm/${id}`)
    },
    cancelAppointment(id, payload) {
        return instance.put(`/appointment/cancel/${id}`, payload || {})
    },
    coachRejectAppointment(id, reason) {
        return instance.put(`/appointment/coach/reject/${id}`, { reason })
    },
    coachCancelAppointment(id, reason) {
        return instance.put(`/appointment/coach/cancel/${id}`, { reason })
    },
    removeAppointment(id) {
        return instance.delete(`/appointment/remove/${id}`)
    },
    completeAppointment(id) {
        return instance.put(`/appointment/complete/${id}`)
    },

    // ==================== 器材模块 ====================
    getEquipmentPage(params) {
        return instance.get('/equipment/page', { params })
    },
    getEquipmentList() {
        return instance.get('/equipment/list')
    },
    getEquipmentInfo(id) {
        return instance.get(`/equipment/getInfo/${id}`)
    },
    saveEquipment(equipment) {
        return instance.post('/equipment/save', equipment)
    },
    updateEquipment(equipment) {
        return instance.put('/equipment/update', equipment)
    },
    removeEquipment(id) {
        return instance.delete(`/equipment/remove/${id}`)
    },
    uploadEquipmentImage(file) {
        const fd = new FormData()
        fd.append('file', file)
        return instance.post('/equipment/upload-image', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 60000,
        })
    },
    uploadEquipmentVideo(file) {
        const fd = new FormData()
        fd.append('file', file)
        return instance.post('/equipment/upload-video', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 180000,
        })
    },

    // ==================== 打卡模块 ====================
    getCheckInPage(params) {
        return instance.get('/checkIn/page', { params })
    },
    saveCheckIn(checkIn) {
        return instance.post('/checkIn/save', checkIn)
    },
    removeCheckIn(id) {
        return instance.delete(`/checkIn/remove/${id}`)
    },
    getCheckInStats(memberId, year, month) {
        return instance.get(`/checkIn/stats/${memberId}`, { params: { year, month } })
    },

    // ==================== 教练评价模块 ====================
    getCoachReviewList(params = {}) {
        return instance.get('/coachReview/list', { params })
    },
    submitMemberReview(data) {
        return instance.post('/coachReview/member/submit', data)
    },
    saveCoachReview(review) {
        return instance.post('/coachReview/save', review)
    },

    // ==================== 教练端模块 ====================
    // 我的学员
    getCoachMembers() {
        return instance.get('/coach/members')
    },
    // 我的课程
    getCoachCourses() {
        return instance.get('/coach/courses')
    },
    saveCoachCourse(course) {
        return instance.post('/coach/course/save', course)
    },
    updateCoachCourse(course) {
        return instance.put('/coach/course/update', course)
    },
    removeCoachCourse(id) {
        return instance.delete(`/coach/course/remove/${id}`)
    },
}
